import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';
import { Page } from '@/shared/models/page.model';
import { MedicoPendenciaResponse } from '../pendencia/medico-pendencia.model';
import { MedicoInconsistenciaResponse } from './medico-inconsistencia.model';
import { MedicoInconsistenciaTotalUfResponse } from './medico-inconsistencia-total-uf.model';

@Injectable({ providedIn: 'root' })
export class MedicoInconsistenciaService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    readonly PATH = SICOM_PATHS.registro.medico.inconsistencia;

    private criarParams(uf?: string | null, page?: number, size?: number): HttpParams {
        let params = new HttpParams();
        if (uf) {
            params = params.set('uf', uf);
        }
        if (page !== undefined && page !== null) {
            params = params.set('page', String(page));
        }
        if (size !== undefined && size !== null) {
            params = params.set('size', String(size));
        }

        return params;
    }

    listarPorUf(uf?: string | null, context?: HttpContext): Observable<MedicoInconsistenciaResponse[]> {
        const params = this.criarParams(uf);

        return this.http.get<MedicoInconsistenciaResponse[]>(`${this.PATH}/total-medicos`, { params, context });
    }

    listarHistoricoPorUf(uf?: string | null, context?: HttpContext): Observable<MedicoInconsistenciaTotalUfResponse[]> {
        const params = this.criarParams(uf);

        return this.http.get<MedicoInconsistenciaTotalUfResponse[]>(`${this.PATH}/consulta/historico`, { params, context });
    }

    listarSexoPorUf(uf?: string | null, context?: HttpContext): Observable<MedicoInconsistenciaTotalUfResponse[]> {
        const params = this.criarParams(uf);

        return this.http.get<MedicoInconsistenciaTotalUfResponse[]>(`${this.PATH}/consulta/sexo`, { params, context });
    }

    listarEspecialidadePorUf(uf?: string | null, context?: HttpContext): Observable<MedicoInconsistenciaTotalUfResponse[]> {
        const params = this.criarParams(uf);

        return this.http.get<MedicoInconsistenciaTotalUfResponse[]>(`${this.PATH}/consulta/especialidade`, { params, context });
    }

    listarNascimentoPorUf(uf?: string | null, context?: HttpContext): Observable<MedicoInconsistenciaTotalUfResponse[]> {
        const params = this.criarParams(uf);

        return this.http.get<MedicoInconsistenciaTotalUfResponse[]>(`${this.PATH}/consulta/nascimento`, { params, context });
    }

    listarCpfPorUf(uf?: string | null, context?: HttpContext): Observable<MedicoInconsistenciaTotalUfResponse[]> {
        const params = this.criarParams(uf);

        return this.http.get<MedicoInconsistenciaTotalUfResponse[]>(`${this.PATH}/consulta/cpf`, { params, context });
    }

    listarFormacaoPorUf(uf?: string | null, context?: HttpContext): Observable<MedicoInconsistenciaTotalUfResponse[]> {
        const params = this.criarParams(uf);

        return this.http.get<MedicoInconsistenciaTotalUfResponse[]>(`${this.PATH}/consulta/formacao`, { params, context });
    }

    listarAnalitico(indicadorId: string, uf?: string | null, page?: number, size?: number, context?: HttpContext): Observable<Page<MedicoPendenciaResponse>> {
        const params = this.criarParams(uf, page, size);
        return this.http.get<Page<MedicoPendenciaResponse>>(`${this.PATH}/consulta/${indicadorId}/analitico`, { params, context });
    }
}
